import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) 8",
    correct: false,
  },
  {
    option: "b) 9",
    correct: false,
  },
  {
    option: "c) 10",
    correct: false,
  },
  {
    option: "d) 11",
    correct: true,
  },
  {
    option: "e) 12",
    correct: false,
  },
];

export default function Question16(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question16: {
          title:
            "Quantos indicadores são monitorados pelo SAI Smart Loop?",
          option: option.option,
          correct: option.correct,
          order: 16
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quantos indicadores são monitorados pelo SAI Smart Loop?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
